export async function updateApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { appAddress, signer, spaceAddress } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for updateApp operation.');
    }
    const updateApp = appRegistryDapp.installer.interface.encodeFunctionData('updateApp', [
        appAddress,
        spaceAddress,
    ]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.installer.address],
        callData: [updateApp],
        signer,
        spaceId: undefined,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
